/*--------------------------------------
             MEDIA PRODUCT 
 --------------------------------------*/
mediaProduct = {
    init: function () {
        // OPEN
        $(".media-product-btn").on("click", function () {
            var key = $(this).data("key");
            var item = $(".media-product.product--" + key);

            if (!item.hasClass("active")) {
                $(".media-product-wrapper").find(".media-product").removeClass("active");
                $(".media-product-wrapper").find(".media-product").height(0)
                item.addClass("active");
                item.height(item.find(".media-product--inner").outerHeight());
            }
        });

        // CLOSE
        $(".media-product__close-btn").on("click", function () {
            var item = $(this).closest(".media-product");
            item.removeClass("active");
            item.height(0);
        });

        // CALC BTN POSITION
        $(".media-product-btn").each(function () {
            var btn = $(this);
            var parent = btn.closest(".media-product-wrapper");

            setTimeout(function () {
                btn.css("top", btn.position().top + btn.outerHeight() / 2 + "px");
            }, 500);
        });
    }
};

$(document).ready(function () {
    mediaProduct.init();
});;

